import { Divider, Grid } from "@material-ui/core";
import { useHistory } from "../../shared/hooks/useHistory";

import { HeaderScreen } from "./header-screen.component";
import { drawerMenuStyles } from "./drawer-menu.styles";
import { MenuOption } from "../../shared/components/MenuOption";
import { myResourcesOptions } from "./utils";

interface MyResourcesProps {
  onClose: () => void;
  onBack: () => void;
}

export const MyResources = (props: MyResourcesProps) => {
  const { onClose, onBack } = props;
  const classes = drawerMenuStyles();
  const history = useHistory();

  const handleClick = (path) => {
    history.push(`/participant${path}`);
    onClose();
  };

  return (
    <Grid
      container
      className={classes.profileScreen}
      data-testid="myresources-screen"
    >
      <HeaderScreen title="My Resources" onBack={onBack} hideSettingsIcon />
      {myResourcesOptions.map((opc) => (
        <>
          <MenuOption
            key={opc.text}
            menuOption={opc}
            onClick={() => handleClick(opc.path)}
          />
          {opc.divider && <Divider className={classes.divider} />}
        </>
      ))}
    </Grid>
  );
};
